import type { ChangedRange } from "@/features/workspace/lib/diffRangeHighlight"

/**
 * Line ranges (1-indexed, inclusive, in `next`) that differ from `prev`: the lines between the common
 * leading and trailing lines. Deletions are not represented, matching ChangedRange's contract.
 */
export function changedRanges(prev: string, next: string): ChangedRange[] {
  if (prev === next) return []
  const a = prev.split("\n")
  const b = next.split("\n")
  let head = 0
  while (head < a.length && head < b.length && a[head] === b[head]) head++
  let tail = 0
  while (tail < a.length - head && tail < b.length - head && a[a.length - 1 - tail] === b[b.length - 1 - tail]) tail++
  const end = b.length - tail
  if (end <= head) return []
  return [{ start_line: head + 1, end_line: end, type: head < a.length - tail ? "replace" : "insert" }]
}
